module.exports = __webpack_public_path__ + "img/solution_building2.92d76047.png";